<template>
    <v-form
        ref="form"
        v-model="isValid"
        @submit.prevent="save()">
        <v-card>
            <v-card-title>
                <span class="headline">{{ isEdit ? "Edit" : "Add" }} {{ entity.singleTitle }}</span>
            </v-card-title>

            <v-card-text>
                <form-search-select
                    v-if="fields.some(e => e.key == 'clientId')"
                    v-model="item.clientId"
                    :field="fields.find(e => e.key == 'clientId')"
                    autofocus
                    validate-on-blur
                    @input="onClientInput"
                    @save="save" />
                <form-search-select
                    v-if="fields.some(e => e.key == 'siteId')"
                    v-model="item.siteId"
                    :field="fields.find(e => e.key == 'siteId')"
                    :filter="filter"
                    validate-on-blur
                    @save="save" />
                <component
                    :is="getComponent(field)"
                    v-for="field in filteredFields"
                    :key="field.value"
                    v-model="item[field.key]"
                    :field="field"
                    validate-on-blur
                    @save="save" />
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
                <app-button
                    v-if="canDelete"
                    color="error"
                    text
                    @click="deleteItem">
                    Delete
                </app-button>
                <v-spacer />
                <app-button
                    v-if="canCancel"
                    color="secondary"
                    text
                    @click="$emit('cancel')">
                    Cancel
                </app-button>
                <app-button
                    v-if="canSave"
                    type="submit"
                    text
                    :disabled="isSaving">
                    Save
                </app-button>
            </v-card-actions>

            <v-progress-linear v-if="isSaving" indeterminate color="blue" />
        </v-card>
    </v-form>
</template>

<script>
import { save } from "@/features/schemas/services/schemaApi"
import formMixin from "@/features/schemas/mixins/formMixin";
import { equal } from "@/services/filtering";

export default {
    components: {
        formSearchSelect: () => import("@/features/schemas/formFields/FormSearchSelect.vue"),
    },
    mixins: [formMixin],
    types: [
        "project"
    ],
    props: {
        scope: {
            type: String,
            default: null
        },
    },
    computed: {
        filteredFields() {
            let manualFields = [
                "clientId",
                "siteId"
            ]
            if (!this.isEdit) {
                manualFields.push("projectStatus");
            }
            return this.fields.filter(e => !manualFields.includes(e.key))
        },
        filter() {
            if (!this.item.clientId) {
                return null;
            }
            return equal("clientId", this.item.clientId, "int");
        }
    },

    methods: {
        async save() {
            if (this.isSaving || this.form && !this.form.validate()) {
                return;
            }
            if (!this.isEdit) {
                this.item.projectStatus = "Active";
            }

            const model = { ...this.item, ...this.fixedValues };
            if (model.siteId) {
                model.clientId = null;
            }

            this.isSaving = true;
            try {
                this.item = await save(this.entityKey, this.scope, model, true);
                this.$emit("input", this.item);
            } finally {
                this.isSaving = false;
            }
        },
        onClientInput() {
            this.item.siteId = null;
        }
    }
}
</script>
